import { Avatar } from '../../../ExternalLibraries';

export default Avatar;
